import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import type { ApplicantDetailsPersonsProps } from '@gov-nx/ui/types';

export const ApplicantDetailsAddress = ({
	individualPerson,
	businessPerson,
}: ApplicantDetailsPersonsProps) => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Component);

	const address = individualPerson
		? (individualPerson.adresaPobytu?.adresaText ?? null)
		: businessPerson
			? (businessPerson.sidloSpolecnosti?.adresaText ?? null)
			: null;

	if (!address) {
		return null;
	}

	return (
		<div>
			<dt className="text-body-s">{t('zadatel.pole.udaje.adresa')}</dt>
			<dd className="text-(--text-secondary)">{address}</dd>
		</div>
	);
};
